import React from 'react'
import {
  IconButton,
  InputAdornment,
  StandardTextFieldProps,
  TextField,
} from '@material-ui/core'
import { Clear, GetApp } from '@material-ui/icons'

interface FileUploadProps extends StandardTextFieldProps {
  onHandleUploadChange?: any
  multiple?: any
  previewFiles?: any
  files?: any
  imagePreview?: any
  children?: React.ReactNode
  accept?: string
  mapData?: string
  disabled?: boolean
  singleFile?: boolean
  singleFileClear?: any
  onRemoveFile?: (index: number) => void
}

export const FileUploadInput: React.FC<FileUploadProps> = ({
  onHandleUploadChange,
  multiple,
  previewFiles,
  files,
  imagePreview,
  children,
  accept,
  mapData,
  disabled,
  singleFile,
  singleFileClear,
  onRemoveFile,
  ...InputProps
}: FileUploadProps) => {
  const onClickHiddenInput = (mapData?: any) => {
    if (mapData) {
      document.getElementById('icon-button-file-' + mapData)?.click()
    } else {
      document.getElementById('icon-button-file')?.click()
    }
  }

  const handleDisplayFileInput = (files: any, mapData?: any) => {
    if (!files) return ''
    if (files?.length === undefined) {
      return files?.name
    }
    if (files?.length === 1) {
      return files[0]?.name
    }
    if (files?.length > 1) {
      // show all names joined instead of "3 files"
      return files.map((f: any) => f?.name).join(', ')
    }
    return ''
  }

  return (
    <>
      <TextField
        {...InputProps}
        disabled={disabled}
        fullWidth
        value={handleDisplayFileInput(files, mapData)}
        onClick={() => {
          if (!disabled && !singleFile) {
            onClickHiddenInput(mapData)
          } else if (!disabled && files?.length === 0 && singleFile) {
            onClickHiddenInput(mapData)
          } else if (!disabled && files?.length > 0 && singleFile) {
            singleFileClear?.([])
          }
        }}
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{
          endAdornment: (
            <>
              <InputAdornment
                position="end"
                onClick={() => {
                  if (files?.length > 0 && singleFile) {
                    singleFileClear?.([])
                  }
                  // else {
                  //   onClickHiddenInput(mapData)
                  // }
                }}
              >
                <IconButton className="transform-180" aria-label="">
                  {singleFile && files?.length > 0 ? <Clear /> : <GetApp />}
                </IconButton>
              </InputAdornment>

              <input
                accept={accept || undefined}
                hidden
                multiple={multiple}
                onChange={e => {
                  if (!singleFile) {
                    onHandleUploadChange?.(e)
                    e.target.value = ''
                  } else if (files?.length === 0 && singleFile) {
                    onHandleUploadChange?.(e)
                    e.target.value = ''
                  }
                }}
                id={
                  mapData ? `icon-button-file-${mapData}` : 'icon-button-file'
                }
                type="file"
              />
            </>
          ),
        }}
      />

      {/* PREVIEW WRAPPER */}
      <div
        className="preview-wrapper"
        style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 8 }}
      >
        {imagePreview
          ? imagePreview
          : children
          ? children
          : previewFiles?.length > 0
          ? previewFiles.map((src: string, i: number) => (
              <div
                key={src + i}
                style={{ position: 'relative', display: 'inline-block' }}
              >
                <img
                  src={src}
                  alt={`preview-${i}`}
                  style={{
                    width: 120,
                    height: 90,
                    objectFit: 'cover',
                    borderRadius: 6,
                  }}
                />
              </div>
            ))
          : null}
      </div>
    </>
  )
}
